import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("chat controller connected")
    // this.boundScrollToBottom = this.scrollToBottom.bind(this)
    // window.addEventListener("turbo:before-stream-render", this.boundScrollToBottom)
  }

  disconnect() {
    // window.removeEventListener("turbo:before-stream-render", this.boundScrollToBottom)
  }

  notify() {
    // alert("notify")
  }

  scrollToBottom() {
    // const container = document.getElementById("messages")
    // if (container) {
    //   container.scrollTop = container.scrollHeight
    // }
  }
}